import {Component, OnInit} from '@angular/core';
import {UserSettingsService} from './services/user-settings.service';
import italianTranslation from './translations/it.json';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import {PrimeNG} from 'primeng/config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [ToastModule, RouterOutlet]
})
export class AppComponent implements OnInit {

    constructor(private primengConfig: PrimeNG, private userSettings: UserSettingsService) {
    }

    ngOnInit(): void {
        const theme = this.userSettings.getTheme();

        this.userSettings.applyTheme(theme);

        this.primengConfig.setTranslation(italianTranslation.it);

    }

}
